<div class="address-field-action">
  <span class="material-icons notranslate">public</span>
  <h3>Country</h3>
  <div class="address-country-field">
    <h4 class="with"><span>with</span></h4>
    <div class="replace-container"
      [ngClass]="{
      'country-disabled': countryControl.disabled
      }">
      <label>
        <app-autocomplete #countryField [selectedOptionControl]="countryControl"
                          [clearInputListener]="inputCleared.asObservable()" [inputRequired]="true"
                          [componentId]="'country-action-fieldValue'"
                          [placeholder]="pickerPlaceholderText ? pickerPlaceholderText : 'Choose a field...'"></app-autocomplete>
      </label>
    </div>
  </div>
</div>
